<template>
    <v-card max-width="500" class="mx-auto">
        <v-card-actions>
            <v-btn text color="blue-grey" router :to="{ name: 'MyPage'}">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="ml-2">돌아가기</span>
            </v-btn>
        </v-card-actions>
        <v-img
            class="white--text"
            height="350px"
            src="/passon.jpg"
        >
            <v-card-title class="align-end fill-height font-italic">Pass On</v-card-title>
        </v-img>
        <v-card-text >
            <p class="text-center my-5 pt-5"><span class="title indigo--text pr-3">은탁선</span>의 새로운 방장을 골라 주세요.</p>
            <!-- text field for Search  -->
            <div class="search mx-auto">
                <v-text-field outlined label="Search" append-icon="search" v-model="search" class="mt-5">
                </v-text-field>
            </div>                
            <!-- groups brought back from db -->
            <v-list two-line subheader v-if="groupMembers">
            <v-subheader>회원들({{ groupMembers.length }})</v-subheader>

                <v-list-item v-for="member in filteredMembers" :key="member.alias">
                    <v-list-item-avatar>
                        <v-img :src="member.avatar"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title v-text="member.name"></v-list-item-title>
                        <v-list-item-subtitle v-text="member.alias"></v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-content>
                        <v-list-item-title>{{ member.total }}</v-list-item-title>
                        <v-list-item-subtitle>
                            {{ member.level }}부                                
                            <span v-for="n in member.level" :key="n">
                                <v-icon small color="orange">mdi-star</v-icon>
                            </span>                            
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-icon>
                        <!-- component -->
                        <SelectNewLeader :user="user" :group="group" :groupId="groupId" :member="member" />
                    </v-list-item-icon>
                </v-list-item>
            </v-list>
        </v-card-text>
        <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading='loading' depressed dark class="my-5" color="blue-grey" @click="passOnAndSignout">선택</v-btn>
            <v-spacer></v-spacer>
        </v-card-actions> -->
    </v-card>
</template>

<script>
import db from '@/fb'
import slugify from 'slugify'
import SelectNewLeader from '@/components/SelectNewLeader'

export default {
    name: 'PassOn',
    components: { SelectNewLeader },
    data: () => ({
        loading: false,
        search: '',
        user: null,
        groupId: null,
        group: null,
        groupMembers: []
    }),
    methods: {
        passOnAndSignout(){

        }
    },
    computed: {
        filteredMembers(){
            return this.groupMembers.filter(member => {
                return member.name.toLowerCase().match(this.search) || member.alias.toLowerCase().match(this.search)
            })
        }
    },
    created(){
        this.groupId = this.$route.params.group_id;
        this.group = this.$route.params.group;
        this.user = this.$route.params.user;

        if(this.group && this.groupId && this.user){
            // aliases
            let aliases = []        
            this.group.members.forEach(member => {
                aliases.push(member.alias)
            })

            // ids
            let ids = aliases.map(alias => {
                return slugify(alias, {
                    replacement: '-',
                    remove: /[$*_+~.()'"!\-:@]/g,
                    lower: true
                })
            })
            
            // users of the group
            let groupMembers = []
            ids.forEach(id => {
                db.collection('users').doc(id).get().then(snapshot => {
                    if(this.user.alias != snapshot.data().alias ){
                        groupMembers.push(snapshot.data())
                    }
                })
            })
            this.groupMembers = groupMembers      
        }  else {
            this.$router.push({ name: 'MyPage'})
        }
    }
}
</script>

<style>

</style>